var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sky-box",style:({ 'background-image': 'url(' + _vm.image + ')', 'background-position': '0px ' + _vm.yPos + 'px' })})}
var staticRenderFns = []

export { render, staticRenderFns }